/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Icon } from './Icon';
import { IconFromJSON, IconFromJSONTyped, IconToJSON } from './Icon';

/**
 *
 * @export
 * @interface MetadataSchema
 */
export interface MetadataSchema {
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof MetadataSchema
	 */
	rID: string;
	/**
	 *
	 * @type {Date}
	 * @memberof MetadataSchema
	 */
	createdAtUtc: Date;
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof MetadataSchema
	 */
	createdByUserRID: string;
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof MetadataSchema
	 */
	containerRID: string;
	/**
	 * The name of the metadata schema
	 * @type {string}
	 * @memberof MetadataSchema
	 */
	name: string;
	/**
	 * Resource type that this metadata schema is allowed to be added to.
	 * @type {string}
	 * @memberof MetadataSchema
	 */
	resourceType: MetadataSchemaResourceTypeEnum;
	/**
	 *
	 * @type {Icon}
	 * @memberof MetadataSchema
	 */
	icon?: Icon;
	/**
	 * JSON Schema definition
	 * @type {object}
	 * @memberof MetadataSchema
	 */
	jsonSchema?: object;
	/**
	 * UI Schema definition
	 * @type {object}
	 * @memberof MetadataSchema
	 */
	uiSchema?: object;
	/**
	 * A template string where placeholders will be replaced by metadata or primary contact property values
	 * @type {string}
	 * @memberof MetadataSchema
	 */
	nameTemplate?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum MetadataSchemaResourceTypeEnum {
	ClientEntity = 'clientEntity',
	ClientContact = 'clientContact',
	ServiceContact = 'serviceContact',
}

/**
 * Check if a given object implements the MetadataSchema interface.
 */
export function instanceOfMetadataSchema(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'rID' in value;
	isInstance = isInstance && 'createdAtUtc' in value;
	isInstance = isInstance && 'createdByUserRID' in value;
	isInstance = isInstance && 'containerRID' in value;
	isInstance = isInstance && 'name' in value;
	isInstance = isInstance && 'resourceType' in value;

	return isInstance;
}

export function MetadataSchemaFromJSON(json: any): MetadataSchema {
	return MetadataSchemaFromJSONTyped(json, false);
}

export function MetadataSchemaFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): MetadataSchema {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		rID: json['RID'],
		createdAtUtc: new Date(json['createdAtUtc']),
		createdByUserRID: json['createdByUserRID'],
		containerRID: json['containerRID'],
		name: json['name'],
		resourceType: json['resourceType'],
		icon: !exists(json, 'icon') ? undefined : IconFromJSON(json['icon']),
		jsonSchema: !exists(json, 'jsonSchema') ? undefined : json['jsonSchema'],
		uiSchema: !exists(json, 'uiSchema') ? undefined : json['uiSchema'],
		nameTemplate: !exists(json, 'nameTemplate') ? undefined : json['nameTemplate'],
	};
}

export function MetadataSchemaToJSON(value?: MetadataSchema | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		RID: value.rID,
		createdAtUtc: value.createdAtUtc.toISOString(),
		createdByUserRID: value.createdByUserRID,
		containerRID: value.containerRID,
		name: value.name,
		resourceType: value.resourceType,
		icon: IconToJSON(value.icon),
		jsonSchema: value.jsonSchema,
		uiSchema: value.uiSchema,
		nameTemplate: value.nameTemplate,
	};
}
